module.exports = __webpack_public_path__ + "img/message-fill.1865e200.svg";